import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function PrivateRoute({ res, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      /* `render`, NOT `component`: an inline arrow passed to `component` is a new component type
         every render, so React remounts the routed page on every App re-render (state reset on
         window/tab refocus). `render` reconciles the stable <Component> instead. */
      render={(props) => {
        if (
          window.localStorage.getItem("token") != "" &&
          window.localStorage.getItem("token")
        ) {
          // Deliberately does NOT consume the deep-link stash. This branch is
          // "you are already signed in and asked for a public page", which is
          // never part of a deep-link sign-in — Login/validateTwoFactorCode own
          // that. Consuming here would also delete during the render phase, and
          // would send an already-signed-in user to their last page instead of
          // /solutions.
          return <Redirect to="/solutions" />;
        } else {
          return (
            <div>
              <Component {...props} />
            </div>
          );
        }
      }}
    />
  );
}
